import Capa from "./Capa";
import { tooltip_cp } from "@/components/mapa/capas/_utils.js";

const VIH_CP_CENTROIDES_LAYER_NAME = "vih:cpostales_puntos";

//
export default class VihCpCentroides extends Capa {
  constructor() {
    super({
      capa: VIH_CP_CENTROIDES_LAYER_NAME,
      titulo: "Centroides de Códigos postales",
      z_index: 3,
    });

    this.tooltip = tooltip_cp;

    this.estilo = {
      circle: {
        fill: { color: "#B726FCbb" },
        stroke: { color: "#fff", width: 1 },
      },
    };

    this.clasificasiones = [
      {
        clasificacion: "personalizada",
        columna: "tot_muestras",
        propiedadObjetivo: "proporcion",
        // clasificacionPersonalizada: [[0, 0], [1, 3], [3, 15], [15, 30], [30, 50],[50,65]],
        clasificacionPersonalizada: [
          [0, 0],
          [1, 4],
          [4, 13],
          [13, 31],
          [31, 78],
          [78, 159],
        ],
        proporciones: [0, 4, 8, 12, 16, 20],
        //clases: 5,
        // Titulo que se muestra en la leyenda de la columna ocupada
        tituloVariable: "",
      },
    ];

    this.tituloLeyenda = "Cantidad de casos positivos a VIH a nivel código postal";
  }
}
